import t from"i18next";import n from"i18next-chained-backend";import{TRANSLATION_OPTIONS as o}from"./constants/translationsOptions.js";const i=t.createInstance();i.use(n).init(o);export{i as i18nInstance};
//# sourceMappingURL=translationsInstance.js.map
